import {
    AnyElementValue, ElementsValues, Nullable,
} from "@data-force/app";
import {UploadFile} from "antd/es/upload/interface";
import {AnyElementType, RefElementsMap} from "@data-force/app/interfaces/store/actions/payload/schema/schemaElements";
import {FileTypeResult} from "file-type/browser";
import {TranslateFunction} from "react-localize-redux";
import {ArgsProps} from "antd/es/message";
import {Result, ResultObject} from "../../types/types";
import {Task, TaskEntity} from "../store/actions/payload/task";
import {FileSelectionType} from "../store/actions/payload/layout";
import {FileTypeAndExtension, UploadsData, UploadsHolder} from "../store/actions/payload/fileValidation";
import {BucketCount, SelectedFiles} from "../store/reducers/uploadFilesState";

export interface FileValidationData {
    fileMediaInfo: Nullable<Result>
    fileMimeType: string
    fileName: string
    fileExtension: Nullable<string>
    uid: string
}

export interface MimeTypeValidationData {
    acceptedMimeTypes: string[]
    fileMimeType: string
    fileName: string
    fileExtension: Nullable<string>
}

export interface UploadsValidationData {
    validationReferences: string[]
    fileMediaInfo: Nullable<Result>
    fileExtension: Nullable<string>
}

export interface ReferenceValidationData {
    reference: string
    referenceValues: Nullable<AnyElementValue>[]
    element: Nullable<AnyElementType>
    elementsValues: ElementsValues
    translate: TranslateFunction
}

export interface ReferenceValueValidationResult {
    referenceValidity: boolean[]
    errors: string[]
}

export interface ReferenceValidationResult {
    fileValidity: boolean[]
    errors: string[]
}

export interface ErrorsData {
    errors: string[]
    reference: string
}

export interface DisplayErrorsData {
    errors: string[]
    fileName: string
    holderIndex: number
}

export interface FileIsValidHolder {
    byMimeType: boolean
    byReferences: boolean
    uploadsHolder: UploadsHolder
    errors: string[]
}

export interface FileTypeAndExtensionData {
    sniffedType: Nullable<FileTypeResult>
    type: string
}

export interface GetReferenceValueData {
    reference: string
    fileMediaInfo: Nullable<Result>
}

export interface CreateTaskFilesData {
    files: UploadFile[]
    numberOfRequiredFiles: number
    tasks: TaskEntity[]
    mappedTaskIds: string[]
    mappedFiles: UploadFile[]
}

export interface MapFilesToTasksData extends CreateTaskFilesData {
    files: UploadFile[]
    fileSelectionType: Nullable<FileSelectionType>
    activeTask: Nullable<Task>
}

export interface FileReferenceValidationData {
    validationReferences: string[]
    collectionRefElements: RefElementsMap
    fileMediaInfo: Nullable<Result>
    elementsValues: ElementsValues
    translate: TranslateFunction
    translatePath: string
}

export interface ValidationData extends FileValidationData {
    uploadsData: UploadsData
    elementsValues: ElementsValues
    collectionRefElements: RefElementsMap
    translate: TranslateFunction
    translatePath: string
    upload?: Nullable<string>
}

export enum Thumbnails {
    VIDEO,
    VIDEO_PLAYABLE
}

export interface FileValidationInfo {
    fileName: string
    validByMimeType: boolean
    validByReferences: boolean
    fileIsValidHolders: FileIsValidHolder[]
    translate: TranslateFunction
}

export interface FileValidity {
    isFileValid: boolean
    validUploadsHolders: UploadsHolder[]
    validationAlerts: ArgsProps[]
}

export interface ErrorMessageData {
    validUploadsHolders: UploadsHolder[]
    translatePath: string
    translate: TranslateFunction
    upload?: Nullable<string>
}

export interface CreateTaskFileData {
    tasks: TaskEntity[]
    mappedTaskIds: string[]
    uploadFile: UploadFile
    finishedTaskIds: string[]
}

export interface MapFileToTaskData extends CreateTaskFileData {
    activeTask: Nullable<Task>
    uploadFile: UploadFile
    fileSelectionType: Nullable<FileSelectionType>
}

export type SniffFileTypeResult = [UploadFile, Nullable<FileTypeResult>];

export type HandleMediaInfoResult = [
    UploadFile,
    Nullable<FileTypeResult>,
    Nullable<ResultObject | string>,
    FileTypeAndExtension,
];

export type UploadsAndReferenceValidationData = UploadsValidationData & FileReferenceValidationData;

export interface ValidByReferenceResult {
    isValidByReference: boolean
    errors: string[]
}

export interface AvailableHolderData {
    uploadsHolders: UploadsHolder[]
    bucketFilesMap: SelectedFiles
    validBatchUploadsConfig: boolean
    bucketCount: BucketCount
}

export interface IconData {
    fileName: string
    translatePath: string
    translate: TranslateFunction
}
